import React from 'react'
import { cx } from '@/lib/utils'
import styles from './ResponsiveGrid.module.scss'

type Cols = '2' | '3' | '4'
type Gap = '4' | '6' | '8'

interface ResponsiveGridProps {
  children: React.ReactNode
  cols?: Cols
  gap?: Gap
}

const colsMap: Record<Cols, string> = {
  '2': styles.cols2,
  '3': styles.cols3,
  '4': styles.cols4,
}

const gapMap: Record<Gap, string> = {
  '4': styles.gap4, '6': styles.gap6, '8': styles.gap8,
}

export const ResponsiveGrid: React.FC<ResponsiveGridProps> = ({
  children, cols = '3', gap = '6',
}) => (
  <div className={cx(styles.grid, colsMap[cols], gapMap[gap])}>
    {children}
  </div>
)
